import React, {useEffect, useState} from 'react'
import {Button, Divider, Form, Image, Menu, Select, Table} from 'antd'
import {connect, useDispatch} from "react-redux"
import {PlusOutlined} from '@ant-design/icons'
import {Headline6, Subtitle1} from "../../../components"
import {createBillingGroup, createBillingRegion, deleteBillingGroup, editBillingGroup, fetchBillingGroupPerState} from '../../../app/Reducers'
import {appLog, createFormInputsFromTableColumns, dialogCloser, emptyFun, executeChunkFn, kebabMenus, makeSelectOptions} from '../../../common/helpers'
import {StateArray} from '../MasterList'
import KebabMenu from '../../../components/KebabMenu'
import {errMsg, toastUp} from "../../../app/Reducers/reducerUtils";
import DynamicModalForm from "../../../components/DynamicModalForm";
import * as Sentry from "@sentry/react";
import GetCookie from '../../../hooks/GetCookie';

let billingRegionInputs = {
    fields: [
        { name: 'state', label: 'State', required: true, type: 'select', options: makeSelectOptions(StateArray), fullRow: true }
    ]
};
const BillingRegions = ({ billingRegions, billingGroups }) => {
    const token = GetCookie('accessToken')
    const uploadUrl = process.env.REACT_APP_ENDPOINT + '/files'
    const [defaultDynamicModalFormValues, setDefaultDynamicModalFormValues] = useState(undefined);
    const onDocUploadChange = ({ fileList: newFileList }) => {
        if(!newFileList[0]){
            setDefaultDynamicModalFormValues({ ...defaultDynamicModalFormValues, logo_id: undefined })
        }
        newFileList = newFileList.map(file => {
            if (file.response) {
                file.url = file.response.url;
                setDefaultDynamicModalFormValues({ ...defaultDynamicModalFormValues, logo_id: file.response.data.id })
            }
            return file;
        });
    };
    const columns = [
        {
            title: 'State', dataIndex: 'state', key: 'state',
            fltr: { filterable: false, type: 'select', options: makeSelectOptions(billingRegions?.map((item) => item.state)), editableCol: true, required: true }
        },
        { title: 'Name', dataIndex: 'name', key: 'name', fltr: { filterable: false, type: 'text', editableCol: true, required: true } },
        {
            title: 'Logo', dataIndex: 'logo', key: 'logo_id', fltr: {
                filterable: false, type: 'upload', editableCol: true, required: false,fullRow:true,
                props: { listType: "text", accept: "image/*", action: uploadUrl, headers: { 'Authorization': `Bearer ${token}` }, onChange: onDocUploadChange, maxCount: 1 }
            },
            render: (logoUrl) => (<Image
                width={80}
                height={80}
                src={logoUrl}
                fallback="data:image/png;base64,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"
            />)
        },
        {
            title: 'Default billing group', dataIndex: 'is_default', key: 'is_default',
            fltr: { filterable: false, type: 'checkbox', editableCol: true, required: false },
            render: (text, record) => (
                <div className="status-container">
                    <div className="dot-circle-active" style={{ background: record.is_default ? '#50D2A0' : "#fc223e" }}/>
                    <Subtitle1>{record.is_default ? 'Yes' : 'No'}</Subtitle1>
                </div>
            )
        },
        {
            title: 'Action',
            render: (record) =>
                (<KebabMenu
                        menus={actionMenus}
                        recordItem={record}
                        handleMenuClick={kebabMenuClick}
                        resource="billing group"
                        handleOk={() => handleOk(record)}
                        showConfirmDialog={selected === record.id}
                        handleCancel={handleCancel}
                        confirmLoading={confirmLoading}
                    />
                )
        }
    ]
    const dateFormat = "YYYY-MM-DD";
    const dispatch = useDispatch()
    const [form] = Form.useForm()
    const [billingGroupForm] = Form.useForm()
    const { Option } = Select;
    const [showAddBillingRegion, setShowAddBillingRegion] = useState(false)
    const [showAddBillingGroup, setShowAddBillingGroup] = useState(false)
    // const [billingGroups, setBillingGroups] = useState(null)
    const [confirmLoading, setConfirmLoading] = useState(false)
    const [loadingBillingGroups, setLoadingBillingGroups] = useState(false)
    const [selected, setSelected] = useState(null)
    const [isExecuting, setisExecuting] = useState(false)
    const [editingForm, setEditingForm] = useState(false)
    const [datePopupOpen, setDatePopupOpen] = useState(false)
    const [popupOpen, setPopupOpen] = useState(false)
    const [phoneValue, setPhoneValue] = useState(undefined);
    const [isDynamicFormOpen, setDynamicFormOpen] = useState(false);
    const [formName, setFormName] = useState(undefined);
    let billingGroupFormInputs = createFormInputsFromTableColumns(false, columns, phoneValue, setPhoneValue, null, null, dateFormat)
    //Do not pass inputs as a useState variable, it causes props of useState values not to propagate state to form items
    let dynamicFormInputFields = {
        'Edit Billing Group': billingGroupFormInputs,
        'Add New Billing Group': billingGroupFormInputs,
        'Add Billing Region': billingRegionInputs
    }
    const handleClick = async e => await getBillingGroups(e.key);

    async function getBillingGroups(state) {
        setLoadingBillingGroups(true)
        await dispatch(fetchBillingGroupPerState(state))
        setLoadingBillingGroups(false)
    }

    const getItem = (label, key, icon, children, type) => ({ key, icon, children, label, type });

    const items = [...billingRegions.map((item) => getItem(item.state, item.state, null, null, null), [])]

    const actionMenus = kebabMenus(true, false, true)
    const showPopconfirm = (id) => setSelected(id);


    async function kebabMenuClick(e, record) {
        switch (actionMenus[e.key].title) {
            case 'Edit':
                await openDefaultBillingGroupDynamicForm(record)
                break
            case 'Delete':
                showPopconfirm(record.id)
                break
            case 'Audit':
                break
            default:
        }
    }

    const handleOk = async (record) => {
        await setConfirmLoading(true)
        await setSelected(0)
        await dispatch(deleteBillingGroup({ id: record.id, state: record.state }))
        await getBillingGroups(record.state)
        await setConfirmLoading(false)
    }

    const handleCancel = () => setSelected(0);

    useEffect(() => {
        getBillingGroups(billingRegions[0].state).catch(appLog)
        return emptyFun
    }, [])

    const openDefaultBillingGroupDynamicForm = async (record) => {
        console.log({ record })
        await setFormName(!!record ? 'Edit Billing Group' : 'Add New Billing Group');
        await setDefaultDynamicModalFormValues(!!record ? { ...record } : undefined);
        await setDynamicFormOpen(true);
    };
    const openDefaultBillingRegionDynamicForm = async () => {
        await setFormName('Add Billing Region');
        await setDefaultDynamicModalFormValues(undefined);
        await setDynamicFormOpen(true);
    };

    /**
     * This function is handling returned form entries from the dynamic form
     * */
    const onDynamicFormEntriesResult = async (entries) => {
        let formdata = { ...entries.values, is_default: entries.values.is_default ? 1 : 0 }
        try {
            switch (formName) {
                case 'Add New Billing Group':
                    await executeChunkFn(dispatch, createBillingGroup, formdata, setisExecuting, dialogCloser(setDynamicFormOpen), async () => await dispatch(fetchBillingGroupPerState(entries.values.state)))
                    break;
                case 'Edit Billing Group':
                    await executeChunkFn(dispatch, editBillingGroup, formdata, setisExecuting, dialogCloser(setDynamicFormOpen), async () => await dispatch(fetchBillingGroupPerState(entries.values.state)))
                    break;
                case 'Add Billing Region':
                    let arr = entries.values?.state?.split('-')
                    let payload = { name: arr[1].trim(), code: arr[0].trim() }
                    await executeChunkFn(dispatch, createBillingRegion, payload, setisExecuting, dialogCloser(setDynamicFormOpen))
                    break;
            }
        } catch (e) {
            Sentry.captureException(e);
            //console.log(e);
            toastUp(errMsg(e, false, formName), false);
        }
    };

    return (
        <div style={{ height: '100%', width: '100%' }} className="flex-boy-row">
            {(isDynamicFormOpen && !!formName) && (
                <DynamicModalForm
                    setDynamicFormOpen={setDynamicFormOpen}
                    isDynamicFormOpen={isDynamicFormOpen}
                    inputFields={dynamicFormInputFields[formName]}
                    onDynamicFormEntriesResult={onDynamicFormEntriesResult}
                    closeModal={dialogCloser(setDynamicFormOpen)}
                    isExecuting={isExecuting} phoneValue={phoneValue}
                    defaultValues={defaultDynamicModalFormValues}
                    formName={formName}
                />
            )}
            <div style={{ width: '150px' }}>
                <div>
                    <Headline6 style={{ marginBottom: '10px' }}>Billing Regions</Headline6>
                    <Button type="primary" icon={<PlusOutlined/>} style={{ marginBottom: '10px' }}
                            onClick={() => openDefaultBillingRegionDynamicForm()}
                    >Add Region</Button>
                </div>
                <Menu
                    onClick={handleClick}
                    style={{ width: '105%' }}
                    defaultSelectedKeys={['Alaska']}
                    items={items}
                    mode="inline"
                />
            </div>
            <Divider type="vertical" style={{ height: '100vh', color: '#696969' }}/>
            <div style={{ flex: 1, width: '100%' }}>
                <div className="flex-boy-row-space" style={{ width: '100%' }}>
                    <Headline6>Billing Groups</Headline6>
                    <Button type="primary" icon={<PlusOutlined/>} style={{ marginBottom: '10px' }}
                            onClick={() => openDefaultBillingGroupDynamicForm()}
                            disabled={loadingBillingGroups}
                    >Add Billing Group</Button>
                </div>
                <div className="w-full"><Table loading={loadingBillingGroups} columns={columns} dataSource={billingGroups}/></div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    billingRegions: state?.masters.billingRegions,
    billingGroups: state?.masters.billingGroups,
    loadingBillingGroups: state?.masters.loadingBillingGroups
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(BillingRegions)
